import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { userStatus, history } from '../_helpers';

const isSessionThere = () => {
  let user = userStatus();

  if ( !user ) {
    return false;
  }

  return true;
}

export const PrivateRoute = ({component: Component, ...rest}) => (
  <Route {...rest} render={props => (
    isSessionThere() === true
    ? <div className="wrapper">
        {
          rest.domainsLoaded ?
            (() => {
              history.isPrivate = true

              const user = userStatus().modules
              const userCanAccess = user[rest.name]

              return <Component
                {...props}
                domainsLoaded={rest.domainsLoaded}
                reloadSidebar={(rest.reloadSidebar ? rest.reloadSidebar : '')}
              />
            })()
           : null
        }
      </div>
    : <div>
        { history.isPrivate = false }
        <Redirect to={{pathname: '/signin', state: {from: props.location}}} />
      </div>
  )} />
)